var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "19pt",
    height: "19pt",
    viewBox: "0 0 98.000000 98.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,98.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670 937 c-39 -30 -70 -85 -70 -122 l0 -39 -33 32 -33 32 -183 0 -183 0 -29 -29 -29 -29 0 -357 0 -357 29 -29 29 -29 277 0 c297 0 326 4 339 52 3 13 6 135 6 272 0 243 -1 250 -22 273 l-21 23 34 0 c42 0 103 36 129 76 24 35 26 109 6 158 -8 18 -29 45 -48 60 -31 23 -44 26 -109 26 -43 -1 -81 -6 -89 -13z m139 -41 c15 -8 33 -21 40 -30 10 -12 9 -14 -9 -9 -16 4 -32 -5 -60 -32 -38 -38 -40 -38 -59 -21 -11 10 -27 16 -36 13 -25 -10 -17 -41 20 -77 35 -33 35 -33 57 -14 42 35 98 97 98 108 0 6 5 3 11 -7 29 -50 -38 -147 -102 -147 -103 0 -155 123 -81 192 43 41 76 47 121 24z m-319 -261 l0 -105 100 0 100 0 0 -215 0 -215 -240 0 -240 0 0 320 0 320 140 0 140 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 380 l0 -50 170 0 170 0 0 50 0 50 -170 0 -170 0 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 220 l0 -50 170 0 170 0 0 50 0 50 -170 0 -170 0 0 -50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedGigs);
export default __webpack_public_path__ + "static/media/AppliedGigs.2dd80ef4.svg";
export { ForwardRef as ReactComponent };